import React from "react";
import { LuLoader2 } from "react-icons/lu";

export const LazyImage = (
  props: React.ImgHTMLAttributes<HTMLImageElement> & {
    width: number;
    height: number;
  },
) => {
  const [loaded, setLoaded] = React.useState(false);
  return (
    <span className="relative inline-block">
      {loaded ? null : (
        <span
          style={{
            width: `${props.width}px`,
            height: `${props.height}px`,
            display: "inline-block",
          }}
        >
          <LuLoader2 className="text-primary h-full w-full animate-spin" />
        </span>
      )}
      <img
        {...props}
        onLoad={() => setLoaded(true)}
        className={loaded ? "" : "absolute"}
      ></img>
    </span>
  );
};
